import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';
import { apiUc } from '../../../http';
import { apiInstagramChat as apiChatTs } from '../../../http';
import * as yup from 'yup';
import { toast } from 'react-toastify';

class QueueService extends ServiceCRUD {
  constructor() {
    super(`/api/filas`);
  }

  getAllSeachQueue(page, size, query, showDisable, login, sortBy, order) {
    return apiUc.get(`${this.path}?q=${query}&showDisable=${showDisable}`, {
      headers: {
        limit: size,
        offset: size * (page - 1),
        login
      },
      params: {
        order: order?.toUpperCase(),
        sortBy: sortBy
      }
    });
  }

  recovery = (id) => {
    return apiUc.put(`${this.path}/${id}/enable`);
  };

  /**
   * Busca a lista de todos os agentes e as filas às quais eles têm permissão.
   * @returns {Promise<any>}
   */
  getAgentsAllowedQueues = () => {
    return apiUc.get(`/api/filas/agentes`);
  };

  async logoutByAgentLoginAndQueueIds(props) {
    const { success, error, data } = yup
      .object({
        login: yup.string().required('É necessário informar um login válido'),
        queuesToLogout: yup
          .array(yup.number())
          .required('É necessário informar quais filas serão deslogadas')
          .min(1, 'Pelo menos uma fila deve ser informada')
      })
      .safeValidateSync(props);

    if (!success) {
      toast.error(
        error?.message ?? 'Não foi possível executar o logout das filas'
      );
      console.error(error);
    }

    const response = await apiChatTs.post(
      `/agent-status-chat/logout-in-queues-chat/${data.login}`,
      {
        queuesToLogout: data.queuesToLogout
      }
    );
    return response.data.data;
  }

  async loginByAgentLoginAndQueueIds(props) {
    const { success, error, data } = yup
      .object({
        login: yup.string().required('É necessário informar um login válido'),
        queuesToLogin: yup
          .array(yup.number())
          .required('É necessário informar em quais filas o agente será logado')
          .min(1, 'Pelo menos uma fila deve ser informada')
      })
      .safeValidateSync(props);

    if (!success) {
      toast.error(
        error?.message ?? 'Não foi possível executar o login nas filas'
      );
      console.error(error);
    }

    const response = await apiChatTs.post(
      `/agent-status-chat/login-in-new-queues-chat/${data.login}`,
      {
        queuesToLogin: data.queuesToLogin
      }
    );
    return response.data.data;
  }
}

export default new QueueService();
